import { render, staticRenderFns } from "./view-exponent.vue?vue&type=template&id=6d2a4092&scoped=true&"
import script from "./view-exponent.vue?vue&type=script&lang=js&"
export * from "./view-exponent.vue?vue&type=script&lang=js&"
import style0 from "./view-exponent.vue?vue&type=style&index=0&id=6d2a4092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a4092",
  null
  
)

export default component.exports